module.exports = __webpack_public_path__ + "static/change-02b73e77cd0aad4a5d612008ee9c301b.png";